import React, { useState, useEffect } from "react";
import moment from "moment";
import ItemDetailsFooter from "./item-details-footer";

const ItemDetailsBody = ({ itemInfo }) => {
  const [renderItems, setRenderItems] = useState([]);

  useEffect(() => {
    if (!itemInfo) {
      return;
    }
    const dates = itemInfo.items.map((item) =>
      moment(item.date).format("YYYY-MM-DD")
    );
    const uniqueDates = [...new Set(dates)];

    const groupedItems = uniqueDates.map((date) => {
      return {
        date,
        amount: itemInfo.items
          .filter((item) => moment(item.date).format("YYYY-MM-DD") === date)
          .reduce(
            (acc, item) =>
              acc + item.paid ? 0 : item.variation?.price || item.price,
            0
          ),
        paymentImages: itemInfo.paymentImages,
        items: itemInfo.items.filter(
          (item) => moment(item.date).format("YYYY-MM-DD") === date
        ),
      };
    });
    setRenderItems(groupedItems);
    //TODO:keep previous selected items  but removed the updated ones
  }, [itemInfo]);

  console.log(renderItems);
  return (
    <div className="item-details-body-container">
      {renderItems.map((item, index) => (
        <div key={index}>
          <div className="item-details-body-item-header">
            <p>{moment(item.date).format("ll")}</p>
            <p style={{ color: item.amount > 0 ? "#CA3C25" : "#6CAE75" }}>
              $
              {parseFloat(
                item.items.reduce(
                  (acc, item) =>
                    acc + (item.paid ? 0 : item.variation?.price || item.price),
                  0
                )
              ).toFixed(2)}
            </p>
          </div>
          {item.items.map((item, index) => (
            <div key={item.id}>
              <div className="item-details-body-item">
                <div className="item-details-body-item-user-image-container">
                  <img src={item.image} alt="profile" />
                  <div className="item-details-body-item-user-info-container">
                    <p>{item.name}</p>
                    <p>{item.description}</p>
                    <p>Added: {item.time}</p>
                  </div>
                </div>
                <div className="item-details-body-item-amount-container">
                  <p>
                    $
                    {parseFloat(item.variation?.price || item.price).toFixed(2)}
                  </p>
                  <p
                    style={{
                      color: item.paid
                        ? "#00A86B"
                        : item.pendingPayment
                        ? "#007fFF"
                        : "FF007F",
                    }}
                  >
                    {item.pendingPayment
                      ? "Pending"
                      : item.paid
                      ? "Paid"
                      : "Unpaid"}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      ))}
      <ItemDetailsFooter text={"Download the app to manage this IOU."} />
    </div>
  );
};

export default ItemDetailsBody;
